import React from 'react';
import ReactTable from 'react-table';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { ROUTES, insertIdtoUrl } from 'constants/Routes.js';
import BusinessCategoryList from './category/BusinessCategoryRow';

/*
 * NOTE:
 * This following block of commented might have some business logic in here.
 * Commenting this out for now but will be complete removed when time comes
 */

// const getIds = (arrayOfObjects) => {
//   const ids = arrayOfObjects.map(obj => obj.id);

//   return ids;
// }

// const BusinessRow = ({
//   business, searchText, surveyTemplateId, deleteBusiness, categoryId
// }) => {
//   const { id, survey_templates, categories, locations, name, plan_subscription } = business;
//   const { trial, trial_remaining } = plan_subscription;
//   const surveyTemplateIds = getIds(survey_templates);
//   const categoryIds = getIds(categories);
//   const includesCategoryId = categoryIds.includes(parseInt(categoryId));
//   const includesTemplateId = surveyTemplateIds.includes(parseInt(surveyTemplateId));
//   const hasSearchText = (name.toLowerCase()).includes(searchText.toLowerCase());
//   const isDefaultView = !(surveyTemplateId || categoryId);
//   const hasSurveyTemplate = surveyTemplateId && includesTemplateId;
//   const hasCategory = categoryId && includesCategoryId;
//   const isVisible = (isDefaultView || hasSurveyTemplate || hasCategory) && hasSearchText;
//   const displayClass = isVisible ? '' : 'd-none';

//   return (
//     <tr
//       key={business.id}
//       className={displayClass}
//     >
//       <td>
//         <NavLink
//           to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id)}
//         >
//           {trial_remaining === 'Expired!' ? <span className='disabled-business'>{name}</span> : name}
//         </NavLink>
//       </td>
//       <td>
//         <NavLink
//           to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id)}
//         >
//           {trial && <span className="trial-text">Trial</span>}
//           {trial_remaining === 'Expired!' ? <b>{trial_remaining}</b> : trial_remaining}
//         </NavLink>
//       </td>
//       <td>
//         <NavLink
//           className="btn btn-outline-secondary btn-sm"
//           to={insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, id)}
//         >
//           View Surveys
//           <span
//             className="ml-1 badge badge-pill badge-secondary"
//           >
//             {locations.length}
//           </span>
//         </NavLink>
//       </td>
//       <td>
//         <NavLink
//           className="btn btn-outline-secondary btn-sm"
//           to={insertIdtoUrl(ROUTES.REPORT_LIST, id)}
//         >
//           View Reports
//         </NavLink>
//       </td>
//       <td className="business-categories">
//         <BusinessCategoryList
//           categories={categories}
//         />
//       </td>
//       <td>
//         <NavLink
//           className="circular-icon icon-cross ml-0"
//           to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id)}
//         >
//           <FontAwesomeIcon icon="pencil-alt" />
//         </NavLink>
//         <span
//           className='circular-icon icon-cross'
//           onClick={deleteBusiness.bind(this, id, name)}
//         >
//           <FontAwesomeIcon icon="trash-alt" />
//         </span>
//       </td>
//     </tr>
//   );
// }

const DEFAULT_PAGE_SIZE = 20;

const BusinessList = props => {
  const {
    searchText,
    businesses,
    deleteBusiness,
    categoryId,
    surveyTemplateId,
  } = props;

  let searchedBusinesses = businesses.slice();

  if (searchText.length > 0) {
    searchedBusinesses = searchedBusinesses.filter(biz =>
      biz.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }

  if (categoryId) {
    searchedBusinesses = searchedBusinesses.filter(biz =>
      biz.categories.find(cat => cat.id == parseInt(categoryId))
    );
  }

  if (surveyTemplateId) {
    searchedBusinesses = searchedBusinesses.filter(business =>
      business.survey_template_ids.includes(parseInt(surveyTemplateId))
    );
  }

  const columns = [
    {
      Header: 'Name',
      id: 'name',
      accessor: 'name',
      Cell: ({ original }) => {
        const { name, id, plan_subscription } = original;
        const { trial_remaining } = plan_subscription;

        return (
          <NavLink to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, id)}>
            {trial_remaining === 'Expired!' ? (
              <span className="disabled-business">{name}</span>
            ) : (
              name
            )}
          </NavLink>
        );
      },
    },
    {
      Header: 'Status',
      id: 'status',
      accessor: d => ({
        trial: d.plan_subscription.trial,
        trialRemaining: d.plan_subscription.trial_remaining,
      }),
      sortMethod: (a, b) => {
        if (!a.trial && b.trial) return -1;
        if (a.trial && !b.trial) return 1;
      },
      Cell: ({ original }) => {
        const { plan_subscription } = original;
        const { trial, trial_remaining, plan } = plan_subscription;
        const { title } = plan;
        const displayTitle = title === 'essential' ? `${title} [free]` : title;

        return (
          <div className="mt-2">
            {
              <span className={`plan-title ${trial ? 'trial' : ''}`}>
                {displayTitle}
              </span>
            }
            {trial_remaining === 'Expired!' ? (
              <b>{trial_remaining}</b>
            ) : (
              trial_remaining
            )}
          </div>
        );
      },
      width: 150,
    },
    {
      Header: 'Surveys',
      sortable: false,
      id: 'surveys',
      Cell: ({ original }) => (
        <NavLink
          className="btn btn-outline-secondary btn-sm"
          to={insertIdtoUrl(ROUTES.CUSTOM_SURVEY_LIST, original.id)}
        >
          View Surveys
          <span className="ml-1 badge badge-pill badge-secondary">
            {original.survey_count}
          </span>
        </NavLink>
      ),
      width: 160,
    },
    {
      Header: 'Reports',
      sortable: false,
      id: 'reports',
      Cell: ({ original }) => (
        <NavLink
          className="btn btn-outline-secondary btn-sm"
          to={insertIdtoUrl(ROUTES.REPORT_LIST, original.id)}
        >
          View Reports
        </NavLink>
      ),
      width: 150,
    },
    {
      Header: 'Categories',
      id: 'categories',
      sortable: false,
      getProps: () => {
        return {
          style: {
            overflow: 'visible',
          },
        };
      },
      Cell: ({ original }) => (
        <div className="business-categories">
          <BusinessCategoryList categories={original.categories} />
        </div>
      ),
    },
    {
      Header: 'Actions',
      sortable: false,
      Cell: ({ original }) => (
        <React.Fragment>
          <NavLink
            className="circular-icon icon-cross ml-0"
            to={insertIdtoUrl(ROUTES.EDIT_BUSINESS_BASIC_INFO, original.id)}
          >
            <FontAwesomeIcon icon="pencil-alt" />
          </NavLink>
          <span
            className="circular-icon icon-cross"
            onClick={deleteBusiness.bind(this, original.id, original.name)}
          >
            <FontAwesomeIcon icon="trash-alt" />
          </span>
        </React.Fragment>
      ),
      width: 120,
    },
  ];

  const pageSize =
    searchedBusinesses.length === 0 ||
    searchedBusinesses.length > DEFAULT_PAGE_SIZE
      ? DEFAULT_PAGE_SIZE
      : searchedBusinesses.length;
  const minRows = searchedBusinesses.length ? 0 : 2;

  return (
    <ReactTable
      className="styled-box-shadow bg-white"
      data={searchedBusinesses}
      columns={columns}
      showPagination
      resizable={false}
      minRows={minRows}
      showPageSizeOptions={false}
      defaultPageSize={pageSize}
    />
  );
};

export default BusinessList;

BusinessList.propTypes = {
  searchText: PropTypes.string,
  categoryId: PropTypes.string,
  businesses: PropTypes.array.isRequired,
  deleteBusiness: PropTypes.func.isRequired,
};

BusinessList.defaultProps = {
  searchText: '',
  categoryId: '',
};



// WEBPACK FOOTER //
// ./src/components/businesses/BusinessList.js